import { Purchase } from "./purchaseModel";
import { Sector } from "./sectorModel";
export class SubSector{
    id : number = 0;
    name : string = "";
    sectorId : number = 0;
    sector!: Sector;
    purchases!: Array<Purchase>;
}